import { render, staticRenderFns } from "./CmgNoLoyaltyForYouModal.vue?vue&type=template&id=065dda78&scoped=true&lang=pug"
import script from "./cmg-no-loyalty-for-you-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-no-loyalty-for-you-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgNoLoyaltyForYouModal.vue?vue&type=style&index=0&id=065dda78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065dda78",
  null
  
)

export default component.exports